import axios from "axios";
import { BASE_URL } from "./APIConstant";
import { encode as btoa } from "base-64";

let basicAuth = btoa("admin:Admin@123");

// Helper to get headers with fresh token
const getAuthHeaders = () => {
    const token = localStorage.getItem("access_token");
    return {
        "Content-Type": "application/json",
        "accept": "application/json",
        ...(token && { "AccessToken": token }),
        "Authorization": `Basic ${basicAuth}`,
    };
};

const headersApplicationJson = {
    "Content-Type": "application/json",
    "accept": 'application/json',
};

// Set up axios interceptor to always include fresh token
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access_token");
        // Only set AccessToken if it exists and is not "undefined" string
        if (token && token !== "undefined" && token !== "null") {
            config.headers["AccessToken"] = token;
        } else {
            // Remove AccessToken header if token is invalid
            delete config.headers["AccessToken"];
        }
        config.headers["Authorization"] = `Basic ${basicAuth}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// Force logout when the server rejects an expired/invalidated session
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const msg = error?.response?.data?.message;
        if (typeof msg === "string" && msg.toLowerCase().includes("session expired")) {
            localStorage.removeItem("access_token");
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export const gameNameApi = (type) => {
    let url = `${BASE_URL}/v1/dashboard/list/?market_type=${type}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const getImageSliderData = (type) => {
    let url = `${BASE_URL}/v1/dashboard/get-image-slider/?market_type=${type}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const uploadImageSLider = (data) => {
    let url = `${BASE_URL}/v1/dashboard/create-image-slider/`;
    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}

export const deleteImageSlider = (id) => {
    let url = `${BASE_URL}/v1/dashboard/delete-image-slider?id=${id}`;
    return axios.delete(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}





export const getuserList = (search) => {
    let url = `${BASE_URL}/v1/user-list/?filter_value=${search}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}
export const getuserTransation = () => {
    let url = `${BASE_URL}/v1/get-withdrawl-list`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}
export const getFundHistory = (id) => {
    let user = id ? `?user_id=${id}` : "";
    let url = `${BASE_URL}/v1/get-user-fund${user}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}
export const getuserTransationByid = (id, start_date, end_date) => {
    let params = [];
    if (id) params.push(`user_id=${id}`);
    if (start_date && end_date) params.push(`start_date=${start_date}&end_date=${end_date}`);
    let url = `${BASE_URL}/v1/get-withdrawl-list${params.length ? '?' + params.join('&') : ''}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const getuserDetails = (id) => {
    let url = `${BASE_URL}/v1/user-list/?user_id=${id}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const deleteUser = (id) => {
    let url = `${BASE_URL}/v1/user-list/?user_id=${id}`;
    return axios.delete(url, {
        headers: headersApplicationJson,
    });
}

export const getNumbers = (type) => {
    let url = `${BASE_URL}/v1/get-numbers-list?number_type=${type}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const getAddNumbers = (number) => {
    let url = `${BASE_URL}/v1/get-add-numbers?number=${number}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}
export const getDashboarddata = () => {
    let url = `${BASE_URL}/v1/main-dashboard-list`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}


export const addFund = (data) => {
    let url = `${BASE_URL}/v1/add-fund/`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}

export const approvedFund = (data) => {
    let url = `${BASE_URL}/v1/accept-withdrawl`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}

export const getDepositList = (depositStatus, start_date, end_date) => {
    let params = [`status=${depositStatus || 'PENDING'}`];
    if (start_date && end_date) params.push(`start_date=${start_date}&end_date=${end_date}`);
    let url = `${BASE_URL}/v1/get-deposit-list?${params.join('&')}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const getFinanceSummary = (start_date, end_date) => {
    let url = `${BASE_URL}/v1/admin-finance-summary`;
    if (start_date && end_date) url += `?start_date=${start_date}&end_date=${end_date}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const acceptDeposit = (data) => {
    let url = `${BASE_URL}/v1/accept-deposit`;
    return axios.post(url, data, {
        headers: headersApplicationJson,
    });
}

export const rejectDeposit = (data) => {
    let url = `${BASE_URL}/v1/reject-deposit`;
    return axios.post(url, data, {
        headers: headersApplicationJson,
    });
}

export const rejectFund = (data) => {
    let url = `${BASE_URL}/v1/reject-withdrawl`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}


export const changePin = (data) => {



    let url = `${BASE_URL}/v1/change-pin/`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const gameRate = () => {
    let url = `${BASE_URL}/v1/get-normal-game-rate`;
    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}
export const gameRateStarline = () => {
    let url = `${BASE_URL}/v1/get-normal-game-rate?game_type=STARLINE`;
    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const deleteGame = (id) => {

    let url = `${BASE_URL}/v1/dashboard/delete/?id=${id}`;

    return axios.delete(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}
export const updateGameName = (data) => {

    let url = `${BASE_URL}/v1/update-game-name`;

    return axios.patch(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const deleteGameResult = (id, is_open) => {
    let isOpen = is_open ? `&is_open=${is_open}` : "";

    let url = `${BASE_URL}/v1/delete-result?id=${id}${isOpen}`;

    return axios.delete(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}


export const updateUserAcitvity = (data) => {

    let url = `${BASE_URL}/v1/update-user-activity`;

    return axios.put(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',
        }
    });
}


export const updateUserPin = (data) => {

    let url = `${BASE_URL}/v1/change-pin`;

    return axios.put(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const withdrawAmountAPi = (data) => {

    let url = `${BASE_URL}/v1/add-withdrawl`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const resultDeclareAPi = (data) => {
    let url = `${BASE_URL}/v1/declare-result`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const barCode = (data) => {
    let url = `${BASE_URL}/v1/merchant`;
    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',
        }
    });
}

export const getbarCode = (data) => {
    let url = `${BASE_URL}/v1/merchant`;
    return axios.get(url, data, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',
        }
    });
}

export const getresultList = (start_date, end_date) => {
    let url = `${BASE_URL}/v1/get-result?start_date=${start_date}&end_date=${end_date}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}


export const addGameApi = (data) => {
    let url = `${BASE_URL}/v1/dashboard/create/`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const getUrl = (uri_value) => {

    let url = `${BASE_URL}/v1/${uri_value}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const updateUpiId = (data, endpoint) => {

    let url = `${BASE_URL}/v1/${endpoint}`;
    if (endpoint === "update-upi") {
        return axios.patch(url, data, {
            headers: {
                "accept": 'application/json',
                "Content-Type": 'application/json',

            }
        });
    }

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',


            "Content-Type": 'application/json',

        }
    });
}

export const updateAppSettings = (data) => {

    let url = `${BASE_URL}/v1/update-app-settings`;
    return axios.patch(url, data, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',

        }
    });
}

export const getAppSetting = () => {

    let url = `${BASE_URL}/v1/get-app-settings`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const getBidHistory = (endpointValue,start_date,end_date,marketId,gameName,gameValue,gameType) => {
    let temp = marketId?`&filter_value=${marketId}`:"";
    let temp2= gameName?`&filter_type=${gameName}`:""
    let temp3= gameValue?`&game_value=${gameValue}`:""
    let temp4= gameType?`&game_type=${gameType}`:""
    let dateParams = start_date && end_date ? `?start_date=${start_date}&end_date=${end_date}` : '?'
    let url = `${BASE_URL}/v1/${endpointValue}${dateParams}${temp}${temp2}${temp3}${temp4}`;
    return axios.get(url, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',
        }
    });
}

export const getTransferHistory = (endpointValue,start_date,end_date) => {

    let url = `${BASE_URL}/v1/${endpointValue}?start_date=${start_date}&end_date=${end_date}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const getUserBidHistory = (endpointValue,user_id) => {

    let url = `${BASE_URL}/v1/dashboard/${endpointValue}/?user_id=${user_id}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',

        }
    });
}
export const getUserWinHistory = (endpointValue,user_id,start_date,end_date) => {

    let url = `${BASE_URL}/v1/dashboard/${endpointValue}/?user_id=${user_id}&start_date=${start_date}&end_date=${end_date}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',

        }
    });
}


export const getSettingInformation = () => {

    let url = `${BASE_URL}/v1/get-information`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}



export const revertBid = (id) => {

    let url = `${BASE_URL}/v1/revert-bid?market_id=${id}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}

export const getBidRevertList = (id) => {

    let url = `${BASE_URL}/v1/revert-bid-list?market_id=${id}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}


export const userBankdetails = (id) => {

    let url = `${BASE_URL}/v1/user-bank-account-details-list/?user_id=${id}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}
export const userUpiDetails = (id) => {

    let url = `${BASE_URL}/v1/get-user-upi/?user_id=${id}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}




export const updateInformation = (data) => {

    let url = `${BASE_URL}/v1/update-information`;

    return axios.patch(url, data, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}


export const getUserTransaction = (id,type) => {

    let url = `${BASE_URL}/v1/transaction-history?user_id=${id}&type=${type}`;

    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });

}

export const getPointCountMarket = (market_id) => {
    let url = `${BASE_URL}/v1/point-count-by-market?market_id=${market_id}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const getDashboardAnk = (market_id, marketType) => {
    let url = `${BASE_URL}/v1/current-ank?market_id=${market_id}&open=${marketType}`;
    return axios.get(url, {
        headers: headersApplicationJson,
    });
}

export const updateGameRate = (data) => {
    let url = `${BASE_URL}/v1/update-game-rate`;
    return axios.put(url, data, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',

        }
    });
}

export const getstarresultList = (start_date,end_date) => {
    let url = `${BASE_URL}/v1/get-result?start_date=${start_date}&end_date=${end_date}&market_type=NORMAL`;
    return axios.get(url, {
        headers: {
            "accept": 'application/json',

            "Content-Type": 'application/json',

        }
    });
}

export const showWinner = (data) => {
    let url = `${BASE_URL}/v1/show-winner`;

    return axios.post(url, data, {
        headers: {
            "accept": 'application/json',
            "Content-Type": 'application/json',
        }
    });
}

export const getChart = (id) => {
    let url = `${BASE_URL}/v1/get-result-for-chart?market_id=${id}`;
    return axios.get(url, {
        headers: headersApplicationJson
    });
}